import { chartTableFlatTransformer } from '../chartTableFlatTransformer';

export const requisitionsTrendTransformer = ({ response }) => {
  const { chart = [], headers, lookups } = response || {};
  const { dt, g1, g2 } = lookups || {};

  const transformedData = chartTableFlatTransformer({
    headers,
    data: chart,
    g1,
    g2,
    dt,
  });

  const categories = []; // x axis data for chart
  const series = []; // y axis data for chart

  // all available keys here are
  // requisitions_opened, requisitions_closed, time_to_fill,

  // Todo: here offers key is hardcoded for now, since only that is used in the chart
  transformedData.forEach(({ dt_display, requisitions_opened }) => {
    categories.push(dt_display); // Use pre-formatted month from transformer
    series.push(requisitions_opened);
  });

  return {
    categories,
    series,
  };
};
